<template>
  <v-icon>mdi-format-list-bulleted</v-icon>
</template>

<script>
export default {
  name: "ListIcon"
}
</script>

<style scoped>

</style>